import QRCode from "react-qr-code";

interface IProps {
  qrUrl: string;
  seconds: number;
  onRefresh: () => void;
}
const QRAuthentication = ({ qrUrl, seconds, onRefresh }: IProps) => {
  // 시간 포맷팅 함수
  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
      .toString()
      .padStart(2, "0")}`;
  };
  return (
    <div className="flex flex-col w-screen items-center">
      <div className="w-[360px] min-w-[360px] py-16  px-4">
        {/* 인증 요청 메시지 */}
        <div className="text-center mb-12 text-[22px] ">
          <div className="text-gray-800">
            <span className="text-red-500 font-bold text-[26px] mr-1">
              ZKP Sample SP
            </span>
            의
          </div>
          <p className="text-[22px] text-[#333]">인증 요청이 있습니다.</p>
        </div>

        {/* QR 코드 섹션 */}
        <div className="bg-white rounded-[12px] py-10 px-4 mt-[64px]">
          {/* 1단계 */}
          <div className="">
            <div className="flex items-center">
              <span className="box-border w-6 h-6 flex justify-center items-center pb-[1.5px] pl-[0.5px] mr-4 rounded-xl text-white bg-gray-800">
                1
              </span>
              <span className="text-[14px] text-gray-800">
                MYKEEPiN 앱 상단에서
                <strong> QR스캔 버튼 선택</strong>
              </span>
            </div>
            <div className="min-h-[68px] mt-6">
              <img
                src="/images/mykeepin-qr-camera.png"
                width={296}
                height={68}
                alt="qr-camera"
              />
            </div>
          </div>

          {/* 2단계 */}
          <div className="mt-[18px]">
            <div className="flex items-center">
              <span className="box-border w-6 h-6 flex justify-center items-center pb-[1.5px] pl-[0.5px] mr-4 rounded-xl text-white bg-gray-800">
                2
              </span>
              <span className="text-[14px] text-gray-800">
                하단의
                <strong> QR코드 스캔</strong>
              </span>
            </div>
          </div>

          {/* QR 코드 */}
          <div className="flex justify-center items-center border-[0.5px] border-[#bdbdbd] mt-6 py-[56px]">
            <div className="flex flex-col items-center">
              <div className="relative">
                {!!qrUrl ? (
                  <QRCode
                    value={qrUrl}
                    size={160}
                    viewBox={`0 0 256 256`}
                    style={{
                      height: "auto",
                      maxWidth: "100%",
                      width: "100%",
                      opacity: seconds === 0 ? 0.3 : 1,
                    }}
                  />
                ) : (
                  <div className="w-[160px] h-[160px] mx-auto flex items-center justify-center bg-gray-200 rounded">
                    <span className="text-gray-500">QR 코드 생성 중...</span>
                  </div>
                )}

                {/* Refresh 버튼 - 타이머가 0일 때만 표시 */}
                {seconds === 0 && (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <button
                      onClick={onRefresh}
                      className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg shadow-lg transition-colors duration-200 flex items-center gap-2"
                    >
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                        />
                      </svg>
                      새로고침
                    </button>
                  </div>
                )}
              </div>

              <div className="text-center mt-6 text-[16px]">
                <span className="text-[#333] mr-1">유효시간</span>
                <span
                  className={`font-bold ${
                    seconds === 0 ? "text-gray-500" : "text-red-500"
                  }`}
                >
                  {seconds === 0 ? "만료됨" : formatTime(seconds)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRAuthentication;
